import React from "react";
import styled from 'styled-components';
import {
  AppBar,
  Button,
  Box,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemText,
  Paper,
  Toolbar,
  Typography
} from "@material-ui/core";
import Client from "../../domain/models/client";
import ClientCard from "../components/client-card";
import ClientFilters from "../components/client-filters";
import PropertyList, { FilterType } from "../../domain/models/property-list";
import Loader from "react-loader-spinner";

const Body = styled.div`
  a {
    font-size: 14px;
  }
  p {
    font-size: 14px;
  }
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 16px;
  }
`;

const BoxLogo = styled(Box)`
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: #ffffff;
  padding-top: 5px;
  padding-bottom: 1x;
  padding-left: 5px;
  padding-right: 5px;
`
const Logo = styled.img`
  height: 40px;
`;
const ItemsContainer = styled.div`
${({ theme }) => `
  /* border: 1px solid ${theme.palette.secondary.main}; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`}
`
const Item = styled.div`
`
const DividerStyled = styled(Divider)`
  width: 75%;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
`
const LoaderContainer = styled.div`
  text-align: center;
`;

type PropsType = {
  clients: Client[];
  propertyLists: PropertyList[];
  onFilterChanged: (filter: FilterType) => void
  onTextFilterChanged: (textFilter: string) => void
  defaultSelected: FilterType,
  defaultTextFilter: string,
  loading: boolean
}

export default function DemosPresenter(props: PropsType) {
  const { clients, propertyLists, onFilterChanged, onTextFilterChanged, defaultSelected, defaultTextFilter, loading } = props

  const renderResults = () => {
    if (loading) {
      return (
        <LoaderContainer>
          <Loader
            type="ThreeDots"
            color="#f9671e"
            height={50}
            width={50}
            timeout={3000} //3 secs
          />
        </LoaderContainer>
      )
    }
    return (
      clients && clients.length > 0 ?
        <Grid container spacing={3}>
          {clients.map(c => <ClientCard key={c.id} client={c} />)}
        </Grid>
        : <div>
          <Typography variant="h6" color="inherit">
            No clients found with that criteria. <Link href="/demos">Clear all filters</Link>.
          </Typography>
        </div>
    )
  }

  return (
    <Body>
      <Container style={{ marginTop: 20, marginBottom: 100 }}>
        <Grid container spacing={3}>
          <Grid item sm={4} md={3}>
            <ClientFilters
              propertyLists={propertyLists}
              onFilterChanged={onFilterChanged}
              onTextFilterChanged={onTextFilterChanged}
              defaultSelected={defaultSelected}
              defaultTextFilter={defaultTextFilter} />
          </Grid>
          <Grid item sm={8} md={9}>
            {renderResults()}
          </Grid>
        </Grid>
      </Container>
    </Body>
  )
}
